import React from 'react';

function Photos() {
  const retroBwStyle = {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '16px',
    border: '2px solid #000000',
    boxShadow: '2px 2px 0px #808080',
    filter: 'grayscale(100%) contrast(160%) brightness(95%)',
    imageRendering: 'pixelated',
    display: 'block'
  };

  return (
    <div style={{ padding: '8px' }}>
      <h2 style={{ fontSize: '14px', marginBottom: '12px', color: '#000080', borderBottom: '1px solid #c0c0c0', paddingBottom: '4px' }}>
        🖼️ Photos - Batuhan Yeşilyurt
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img alt="Batuhan - Outdoor" src={require('../../assets/batuhan1.jpg')} style={retroBwStyle} />
        <img alt="Batuhan - Portrait" src={require('../../assets/batuhan2.jpg')} style={retroBwStyle} />
      </div>
    </div>
  );
}

export default Photos;